import Grid from '@mui/material/Grid';

import Eyebrow from '@/components/Eyebrow/Eyebrow';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import type { Contentful } from '@/contentful/contentful-exports';
import useGlobalStyles from '@/styles/global.styles';
import Heading from '../Heading/Heading';
import type { CardFields } from './Cards/Cards';
import useStyles from './HighlightCards.styles';
import TabbedCards from './TabbedCards/TabbedCards';

export interface HighlightCardsContent extends Contentful {
  fields: {
    cards: CardFields[];
    headline?: string;
    subheading?: string;
    eyebrow?: string;
    style: string;
  };
}

interface HighlightCardsProps {
  content: HighlightCardsContent;
}

const HighlightCards = ({ content: { fields } }: HighlightCardsProps) => {
  const { headline, eyebrow, subheading, style, cards } = fields;
  const isOnDark = style === 'OnDark';
  const { classes, cx } = useStyles({ isOnDark });
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <SpacingContainer className={classes.container}>
      <GridContainer fixed gridProps={{ className: classes.grid }}>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          {eyebrow && <Eyebrow text={eyebrow} isOnDark={isOnDark} />}
          {headline && (
            <Heading level='h2' className={classes.headline}>
              {headline}
            </Heading>
          )}
          {subheading && (
            <p className={cx(classes.subhead, globalClasses.bodyLg)}>
              {subheading}
            </p>
          )}
        </Grid>
        <Grid size={12}>
          <TabbedCards cards={cards} isOnDark={isOnDark} />
        </Grid>
      </GridContainer>
    </SpacingContainer>
  );
};

export default HighlightCards;
